import { useState, useEffect } from "react";
import { useBrand } from "@/contexts/cdpConfig";
import { fetchWithTimeout } from "@/utils";
const leadValueTransformer = (rawLeadValue) => {
    var _a;
    return ({
        qval: "" + ((_a = rawLeadValue.qval) !== null && _a !== void 0 ? _a : 0),
        qfact: "" + rawLeadValue.qfact,
        qval_cand: "" + rawLeadValue.qval_cand,
    });
};
const seekerLeadValuePath = "/seeker-lead-value";
export const useLeadValue = ({ crsBaseUrl, legacyId, shouldSendLeadValue, }) => {
    const [leadValue, setLeadValue] = useState(null);
    const brand = useBrand();
    useEffect(() => {
        const fetchLeadValue = async () => {
            if (shouldSendLeadValue && crsBaseUrl && legacyId && !leadValue) {
                const seekerLeadUrl = `${crsBaseUrl}${seekerLeadValuePath}/${legacyId}?brand=${brand}`;
                try {
                    await fetchWithTimeout(seekerLeadUrl, {
                        method: "GET",
                        mode: "cors",
                        headers: {
                            Accept: "application/json",
                        },
                    })
                        .then((response) => response.json())
                        .then((data) => setLeadValue(leadValueTransformer(data)));
                }
                catch (error) {
                    console.error("fetchLeadValue: An error occurred while fetching.", error);
                }
            }
        };
        fetchLeadValue();
    }, [shouldSendLeadValue, crsBaseUrl, legacyId, leadValue, brand]);
    return leadValue;
};
